
    // document.getElementById('prod-10050526445841').addEventListener('click', function (e) {
    //     e.preventDefault()
    //     const products = {
    //     products: [
    //         {
    //             sku: 'DQC16105',
    //             absoluteQuantity: 3
    //         },
    //         {
    //             sku: 'DQC14805',
    //             absoluteQuantity: 3
    //         },
    //         {
    //             sku: 'DQC164025',
    //             absoluteQuantity: 3
    //         },
    //         {
    //              sku: 'DQ03020',
    //              absoluteQuantity: 6,
    //              customAttributes: [
    //                 {
    //                 key: 'PROMO',
    //                 value: 'Retinol Bundle 1'
    //                 }
    //             ]
    //         }
    //     ]
    //   };
    //   window.spark.updateCart(products);
    // });

    if(document.getElementById('prod-10077773529361')){
      document.getElementById('prod-10077773529361').addEventListener('click', function (e) {
          e.preventDefault()
          const products = {
          products: [
              {
                  sku: 'DQCH003',
                  absoluteQuantity: 1, 
                  customAttributes: [
                        {
                        key: 'PROMO',
                        value: 'Holiday Promo 3'
                        }
                   ]
              }
          ]
        };
        window.spark.updateCart(products);
      })
    }

    if(document.getElementById('prod-10212161290513')){
          document.getElementById('prod-10212161290513').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCTCS001',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'The Triple Cleanse Set'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }

    if(document.getElementById('prod-10212157882641')){
          document.getElementById('prod-10212157882641').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCLYS001',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'The LYS Set'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }



    if(document.getElementById('prod-10077949788433')){
      document.getElementById('prod-10077949788433').addEventListener('click', function (e) {
          e.preventDefault()
          const products = {
          products: [
              {
                  sku: 'DQCH002',
                  absoluteQuantity: 1, 
                  customAttributes: [
                        {
                        key: 'PROMO',
                        value: 'Holiday Promo 2'
                        }
                   ]
              }
          ]
        };
        window.spark.updateCart(products);
      })
    }

    if(document.getElementById('prod-10077978001681')){
      document.getElementById('prod-10077978001681').addEventListener('click', function (e) {
          e.preventDefault()
          const products = {
          products: [
              {
                  sku: 'DQCH001',
                  absoluteQuantity: 1, 
                  customAttributes: [
                        {
                        key: 'PROMO',
                        value: 'Holiday Promo 1'
                        }
                   ]
              }
          ]
        };
        window.spark.updateCart(products);
      })
    }
    
    if(document.getElementById('prod-10145450328337')){
      document.getElementById('prod-10145450328337').addEventListener('click', function (e) {
          e.preventDefault()
          const products = {
          products: [
              {
                  sku: 'DQC05740',
                  absoluteQuantity: 3
              },
              {
                  sku: 'DQC03660',
                  absoluteQuantity: 3
              },
              {
                  sku: 'DQC16610',
                  absoluteQuantity: 3            
              },
              {
                  sku: 'DQC10910',
                  absoluteQuantity: 3,
              },
              {
                  sku: 'DQC05510',
                  absoluteQuantity: 3
              },
              {
                  sku: 'DQC15220',
                  absoluteQuantity: 3
              },
              {
                  sku: 'DQC05605',
                  absoluteQuantity: 3
              },
              {
                   sku: 'DQC003-BOGO',
                   absoluteQuantity: 6,
                   customAttributes: [
                        {
                        key: 'PROMO',
                        value: 'Pure Peptide Extension Promo'
                        }
                   ]
              }
          ]
        };
        window.spark.updateCart(products);
      });
    }

if (document.getElementById('prod-10398067720465')) {
    document.getElementById('prod-10398067720465').addEventListener('click', function (e) {
        e.preventDefault();

        const products = [
            { quantity: 3, id: 47880446935313 }, // Replace with actual variant ID
            { quantity: 3, id: 47880447000849 },
            { quantity: 3, id: 50005993914641 },
            { quantity: 3, id: 47880447033617 },
            { quantity: 3, id: 47880447197457 },
            { quantity: 3, id: 47880447230225 },
            { quantity: 3, id: 47880447164689 },
            { quantity: 3, id: 47880447262993 },
            { quantity: 3, id: 47880447131921 }
        ]; // Ensure you're using variant IDs instead of SKUs

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: products })
        })
        .then(response => response.json())
        .then(data => {
            alert("Products have been added to your cart successfully!");
            location.reload(); // Refresh the page after a short delay
        })
        .catch(error => {
            console.error('Error:', error);
            alert("Failed to add products to cart. Please try again.");
        });
    });
}
if(document.getElementById('prod-10375086702865')){
          document.getElementById('prod-10375086702865').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRBB01',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375080673553')){
          document.getElementById('prod-10375080673553').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRHC01',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375093977361')){
          document.getElementById('prod-10375093977361').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRBB02',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375093911825')){
          document.getElementById('prod-10375093911825').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRHC02',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094206737')){
          document.getElementById('prod-10375094206737').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRBB03',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094075665')){
          document.getElementById('prod-10375094075665').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRHC03',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094370577')){
          document.getElementById('prod-10375094370577').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRBB04',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094239505')){
          document.getElementById('prod-10375094239505').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRHC04',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094501649')){
          document.getElementById('prod-10375094501649').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRBB05',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10375094436113')){
          document.getElementById('prod-10375094436113').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'DQCSRHC05',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10212161650961')){
          document.getElementById('prod-10212161650961').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'fathers-day',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }
if(document.getElementById('prod-10212161880337')){
          document.getElementById('prod-10212161880337').addEventListener('click', function (e) {
              e.preventDefault()
              const products = {
              products: [
                  {
                      sku: 'dermaclear-line',
                      absoluteQuantity: 1, 
                      customAttributes: [
                            {
                            key: 'PROMO',
                            value: 'Bundle'
                            }
                       ]
                  }
              ]
            };
            window.spark.updateCart(products);
          })
        }